import { getCookie } from './ads-info'

export const GA4_MEASUREMENT_ID = 'G-4QJD2NPR94'

const GA_CLIENT_COOKIE = '_ga'
const GA_SESSION_COOKIE = `_ga_${GA4_MEASUREMENT_ID.replace(/^G-/, '')}`

export interface GaDepositInfo {
  ga_cookie: string
  ga_session_cookie: string
  client_id: string
  session_id: string
}

// "GA1.1.1234567890.1700000000" -> "1234567890.1700000000"
export const parseGaClientId = (cookie: string) => {
  const match = cookie.match(/^GA\d+\.\d+\.(\d+\.\d+)$/)
  return match?.[1] ?? ''
}

// "GS1.1.1700000000.5.1.1700000100.0.0.0" -> "1700000000"
// "GS2.1.s1700000000$o5$g1$t1700000100$j0$l0$h0" -> "1700000000"
export const parseGaSessionId = (cookie: string) => {
  const match =
    cookie.match(/^GS1\.\d+\.(\d+)\./) ?? cookie.match(/^GS2\.\d+\.s(\d+)/)
  return match?.[1] ?? ''
}

// Read at deposit start so the backend can store it against the billno and
// reuse it when the deposit confirms server-side (Measurement Protocol).
export const getGaDepositInfo = (): GaDepositInfo => {
  try {
    const gaCookie = getCookie(GA_CLIENT_COOKIE)
    const gaSessionCookie = getCookie(GA_SESSION_COOKIE)

    return {
      ga_cookie: gaCookie,
      ga_session_cookie: gaSessionCookie,
      client_id: parseGaClientId(gaCookie),
      session_id: parseGaSessionId(gaSessionCookie),
    }
  } catch (error) {
    // A malformed cookie must not block the deposit
    return {
      ga_cookie: '',
      ga_session_cookie: '',
      client_id: '',
      session_id: '',
    }
  }
}
